export default __webpack_public_path__ + "content/media/15.72dc263d.jpg";